<script setup>
import { DocumentIcon } from "@heroicons/vue/24/outline";
import { UserIcon } from "@heroicons/vue/24/solid";
import ActionButton from "@js/components/ActionButton.vue";
import { getFileExtension } from "@js/utils/file";
import { useI18n } from "vue-i18n";

const {
  name,
  message,
  date,
  attachments = [],
  icon = null,
  right = false,
} = defineProps({
  name: {
    type: String,
    required: true,
  },
  message: {
    type: String,
    required: true,
  },
  date: {
    type: String,
    required: true,
  },
  attachments: {
    type: Array,
    required: false,
  },
  icon: {
    type: [Object, Function],
    required: false,
  },
  right: {
    type: Boolean,
    required: false,
  },
});

const { t } = useI18n();
</script>

<template>
  <div class="flex gap-2" :class="{ 'justify-end': right }">
    <div
      class="inline-flex size-8 items-center justify-center rounded-full bg-indigo-600 text-white"
    >
      <component v-if="icon" :is="icon" class="size-6" />
      <UserIcon v-else class="size-6" />
    </div>

    <div
      class="max-w-[80%] rounded-b-lg rounded-r-lg bg-gray-50 px-4 py-3 drop-shadow"
    >
      <div class="mb-4 flex items-center justify-between gap-4">
        <div class="font-bold">
          {{ name }}
        </div>

        <div class="text-xs italic">
          {{ date }}
        </div>
      </div>

      {{ message }}

      <div
        v-if="attachments && attachments.length > 0"
        class="mt-4 flex flex-wrap gap-4"
      >
        <ActionButton
          v-for="(attachment, index) in attachments"
          :key="index"
          :href="attachment"
          target="_blank"
          :left-icon="DocumentIcon"
        >
          <template v-if="getFileExtension(attachment)">
            ({{ getFileExtension(attachment) }})
          </template>
          <template v-else>
            {{ t("button.unknown") }}
          </template>
        </ActionButton>
      </div>
    </div>
  </div>
</template>
